export const REM_BASE_PX = 10; // matches :root { font-size: 62.5% } in App.css

export const pxToRem = (px: number): string => `${px / REM_BASE_PX}rem`;
